import React, { useEffect, useRef } from "react";
import mapboxgl from 'mapbox-gl';
import "mapbox-gl/dist/mapbox-gl.css";
import demoAvatar from "src/assets/images/avatars/avatar.png";
import {
  CAvatar,
  CButton,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CFormLabel,
} from '@coreui/react'

const Mapbox = (props) => {
  const mapContainerRef = useRef(null);
  const latitude =23.4241;
  const longitude=53.8478;
  // const locations = [
  //   { latitude: 23.8103, longitude: 90.4125, name: "Dhaka", zoom: 0 },
  //   { latitude: 23.9010, longitude: 90.4088, name: "Tongi", zoom: 0 },
  //   { latitude: 23.8479, longitude: 90.2576, name: "Savar", zoom: 0 },
  //   { latitude: 40.7128, longitude: -74.006, name: "New York", zoom: 0 },
  //   { latitude: 51.5074, longitude: -0.1278, name: "London", zoom: 0 },
  //   { latitude: 20.5937, longitude: 78.9629, name: "India", zoom: 0 },
  //   { latitude: 30.3753, longitude: 69.3451, name: "Pakistan", zoom: 0 },
  //   { latitude: 26.8206 , longitude: 30.8025, name: "Egypt", zoom: 6 },
  //   { latitude: 25.2048, longitude: 55.2708, name: "Dubai", zoom: 0 },
  //   { latitude: 61.9241, longitude: 25.7482, name: "Finland", zoom: 6 },
  //   // Add more locations as needed
  // ];

  // const customMarker = document.createElement('div');
  // customMarker.style.backgroundImage = 'url(../../../assets/images/pin.svg)';
  // customMarker.style.backgroundSize = 'cover';
  // customMarker.style.backgroundPosition = 'center';
  // customMarker.style.width = '27px';
  // customMarker.style.height = '41px';
  useEffect(() => {
    mapboxgl.accessToken = 'pk.eyJ1Ijoid3NpdC1zYW1pdWwiLCJhIjoiY2xqM3g1b3FoMWtpODNyb2RmM2V1aTJzbCJ9.u870I5zQLy6w3dWBby5siw';
    const locations = props.data;
    console.log(locations)
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/wsit-samiul/clj3xauf9008501micfqm31y8',
      center: [longitude, latitude], // Set the initial map center coordinates
      zoom: 6 // Set the initial map zoom level
    });

    locations.forEach((location) => {
      new mapboxgl.Marker({
        // anchor: 'bottom',
        // element: customMarker,
      })
        .setLngLat([location.longitude, location.latitude])
        .setPopup(new mapboxgl.Popup().setHTML(`<div><p>${location.name}</p><img width="30px" src="${demoAvatar}"/></div>`))
        .addTo(map);
    });

    map.on('load', () => {
      map.resize();
    });  

    return () => map.remove();
  }, [props]);

  return (
    <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={4}>
              <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput1">Booking Order ID: {props.item?.bookingOrderId}</CFormLabel><br/>
                  <CFormLabel htmlFor="exampleFormControlInput1">Transfer Order No: {props.item?.transferOrderNo}</CFormLabel>
                  
                  {/* <CFormInput type="email" id="exampleFormControlInput1" placeholder="example:DD001" value={bookingOrderId} onChange={(e)=>setBookingOrderId(e.target.value)}/> */}
              </div>
            </CCol>
            <CCol sm={4}>
              <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput1">From: {props.item?.fromLocation?.name}</CFormLabel><br/>
                  <CFormLabel htmlFor="exampleFormControlInput1">To: {props.item?.toLocation?.name}</CFormLabel>
                  {/* <CFormInput type="email" id="exampleFormControlInput1" placeholder="example:DD001" value={transferOrderNo} onChange={(e)=>setTransferOrderNo(e.target.value)}/> */}
              </div>
            </CCol>
            <CCol sm={4}>
              <div className="mb-3">
                  {/* <CFormLabel htmlFor="exampleFormControlInput1">Vehicle ID:{props.item?.tripVehicleId}</CFormLabel><br/> */}
                  <CFormLabel htmlFor="exampleFormControlInput1">Tag ID:{props.item?.tripTagId}</CFormLabel><br/>
                  <CFormLabel htmlFor="exampleFormControlInput1">Driver: {props.item?.tripAssignedTo?.firstName} {props.item?.tripAssignedTo?.lastName}</CFormLabel><br/>
                  <CFormLabel htmlFor="exampleFormControlInput1">Last Location: {props.item.driverLocation?.updatedAt}</CFormLabel><br/>
                  {/* <CFormInput type="email" id="exampleFormControlInput1" placeholder="example:DD001" value={sealBag} onChange={(e)=>setSealBag(e.target.value)}/> */}
              </div>
            </CCol>
          </CRow>
          <CRow>
          <div ref={mapContainerRef} style={{ width: '100% !important', height: '800px' }} />
          </CRow>
        </CCardBody>
     </CCard>
  // <div>
  //   <p>From: {props.item?.fromLocation?.name}</p>
  //   <p>To: {props.item?.toLocation?.name}</p>
  //   <div ref={mapContainerRef} style={{ width: '100% !important', height: '800px' }} />
  // </div>
  )
}

export default Mapbox;
